import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSolarPanel, faTools, faChargingStation } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../../components/Navbar';
import { Helmet } from 'react-helmet-async';
import DragupButton from '../../components/DragupButton';
import Footer from '../../components/Footer';
import './Leistungen.css'; // Link to the CSS file

function Leistungen() {
  return (
    <>
      <Helmet>
        <title>Leistungen | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/leistungen" />
      </Helmet>
      <DragupButton />
      <Navbar />

      <div className="leistungen-container">
        <h1 className="leistungen-title">Unsere Leistungen</h1>
        <div className="leistungen-grid">
          {/* Photovoltaik Card */}
          <Link to="/leistungen/photovoltaik" className="leistungen-card photovoltaik">
            <div className="card-content">
              <FontAwesomeIcon icon={faSolarPanel} className="card-icon" />
              <h3>Photovoltaik</h3>
              <p>
                Nutzen Sie die Kraft der Sonne und profitieren Sie von den zahlreichen Vorteilen, die unsere Photovoltaik-Lösungen bieten.
              </p>
              <span>mehr erfahren &rarr;</span>
            </div>
          </Link>

          {/* Elektro Installation Card */}
          <Link to="/leistungen/installation" className="leistungen-card elektro-installation">
            <div className="card-content">
              <FontAwesomeIcon icon={faTools} className="card-icon" />
              <h3>Elektro Installation</h3>
              <p>
                Professionelle Elektroinstallationen für Ihr Zuhause – sicher, effizient und individuell angepasst.
              </p>
              <span>mehr erfahren &rarr;</span>
            </div>
          </Link>

          {/* Landestation Card */}
          <Link to="/leistungen/landestation" className="leistungen-card landestation">
            <div className="card-content">
              <FontAwesomeIcon icon={faChargingStation} className="card-icon" />
              <h3>Landestation</h3>
              <p>
                Intelligente und nachhaltige Lösungen für Ihre Elektromobilität – mit modernster Wallbox-Technologie.
              </p>
              <span>mehr erfahren &rarr;</span>
            </div>
          </Link>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Leistungen;
